export enum MapArea {
    WORLD = 'WORLD',
    VIEWPORT = 'VIEWPORT'
}

export interface ToggleableFilterSelectionOptions {
    potentialTimingPointsOnly: boolean;
}

export interface SelectedFilters {
    areaSelection: MapArea;
    toggleableSelectionOptions: ToggleableFilterSelectionOptions;
}
